
import {
    Form,
    FormField,
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableCell,
    TableBody,
    Table,
    Checkbox, TextArea
} from "semantic-ui-react"
import { Link } from "react-router-dom";
import { statusMap } from "../common/helpers";

export const PreviousReadinessModal = props => {

    if(!props.team) {
        return <div>There is no previous readiness.</div>
    }
    return (
        <div align="center">
            <div style={{width: "100%"}}>
                <Form style={{ width: "100%" }}>
                    <FormField>
                        <label>Members</label>
                        {props.members.length ? <Table celled striped unstackable textAlign="center">
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell>Member</TableHeaderCell>
                                    <TableHeaderCell>Reason, if applicable</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {props.members.map((member) => {
                                    return <TableRow key={member.id}>
                                        <TableCell>
                                            <Link to={'/members/' + member.member_info.id + '/view'}>{member.member_info.name}</Link>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                                {statusMap[member.status_reason] ? statusMap[member.status_reason] : member.status_reason}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table> : "No members"}
                    </FormField>
                    <FormField>
                        <label>Assets</label>
                        {props.assets.length ? <Table celled striped compact unstackable textAlign="center">
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell style={{ minWidth: "8rem" }}>Asset</TableHeaderCell>
                                    <TableHeaderCell>Status</TableHeaderCell>
                                    <TableHeaderCell>Notes</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {props.assets.map((asset) => {
                                    return <TableRow style={{ height: "5rem" }} key={asset.id}>
                                        <TableCell>
                                            <Link to={'/assets/' + asset.asset_info.id + '/view'}>{asset.asset_info.name}</Link>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                                {statusMap[asset.status_reason] ? statusMap[asset.status_reason] : asset.status_reason}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {asset.status_reason !== "functional" &&
                                            <p>{asset.asset_info.notes}</p>
                                            }
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table> : "No assets"}
                    </FormField>
                    <FormField>
                        <label>Status</label>
                        <div>
                            {props.team.status_reason.split(",").map(val => {
                                return statusMap[val]
                            }).join(", ")}
                        </div>
                    </FormField>
                    <FormField>
                        <label>Team ready</label>
                        <Checkbox toggle checked={props.team.status === "ready"} disabled />
                    </FormField>
                    <FormField>
                        <label>Notes</label>
                        <TextArea
                            value={props.team.notes}
                            readonly
                        />
                    </FormField>
                </Form>
            </div>
        </div>
    )
}